export default __webpack_public_path__ + "static/media/Shoe.f92628ae.svg";